import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {VisitContext} from "../../../visit-context";
import {HarbourDuesDeclaration, HarbourDuesLogItem} from "@portbase/bezoekschip-service-typescriptmodels";
import {ComparatorChain} from "../../../../common/comparator-chain";

@Component({
  selector: 'app-harbour-dues-history-tab',
  templateUrl: './harbour-dues-history.component.html',
  styleUrls: ['./harbour-dues-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HarbourDuesHistoryComponent {

  context = VisitContext;
  readonly declaration = input<HarbourDuesDeclaration | null>(null);
  readonly reverseOrder = signal(true);
  private readonly logComparator = new ComparatorChain('timestamp').compare;

  readonly items = computed<HarbourDuesLogItem[]>(() => {
    const logItems = this.declaration()?.logItems ?? [];
    return [...logItems].sort(this.logComparator);
  });

  readonly displayItems = computed<HarbourDuesLogItem[]>(() => {
    const base = this.items();
    return this.reverseOrder() ? [...base].reverse() : base;
  });

  cast = (item: HarbourDuesLogItem): HarbourDuesLogItem => item;

  toggleOrder() {
    this.reverseOrder.update(v => !v);
  }
}
